const basicFields = [
  {
    ID: 347,
    accessor: "data_347",
    Header: "Checklist Column",
    typeDictID: 1,
    sheetID: 111,
    orderBy: 1,
    isShared: false,
    canEdit: true,
    canEditHeader: true,
    canFilter: true,
    canDelete: true,
  },
  {
    ID: 348,
    accessor: "data_348",
    Header: "Text Column",
    typeDictID: 2,
    sheetID: 111,
    orderBy: 2,
    isShared: false,
    canEdit: true,
    canEditHeader: true,
    canFilter: true,
    canDelete: true,
  },
];

const extendedFields = [
  {
    ID: 419,
    accessor: "data_419",
    Header: "Gender",
    typeDictID: 8,
    sheetID: 111,
    orderBy: 3,
    isShared: true,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "picker",
      icon: "venus-mars fas",
      multiSelect: false,
      options: [
        {
          ID: 8,
          title: "Female",
        },
        {
          ID: 9,
          title: "Male",
        },
      ],
      entityType: "user",
      title: "Gender",
      networkAvailableFieldID: 2,
    },
  },
  {
    ID: 416,
    accessor: "data_416",
    Header: "Number Column",
    typeDictID: 3,
    sheetID: 111,
    orderBy: 4,
    isShared: true,
    canEdit: true,
    canEditHeader: true,
    canFilter: true,
    canDelete: true,
  },
  {
    ID: 378,
    accessor: "data_378",
    Header: "SomeWord",
    typeDictID: 2,
    sheetID: 111,
    orderBy: 5,
    isShared: true,
    canEdit: true,
    canEditHeader: true,
    canFilter: true,
    canDelete: true,
  },
  {
    ID: 420,
    accessor: "data_420",
    Header: "Shirt Size",
    typeDictID: 8,
    sheetID: 111,
    orderBy: 6,
    isShared: false,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "picker",
      icon: "male fas",
      multiSelect: false,
      options: [
        {
          ID: 1,
          title: "XS",
        },
        {
          ID: 2,
          title: "Small",
        },
        {
          ID: 3,
          title: "Medium",
        },
        {
          ID: 4,
          title: "Large",
        },
        {
          ID: 5,
          title: "XL",
        },
        {
          ID: 6,
          title: "XXL",
        },
        {
          ID: 7,
          title: "XXXL",
        },
      ],
      entityType: "user",
      title: "Shirt Size",
      networkAvailableFieldID: 1,
    },
  },
  {
    ID: 120,
    accessor: "data_120",
    Header: "Signed Up Date",
    typeDictID: 12,
    sheetID: 111,
    orderBy: 7,
    isShared: true,
    canEdit: false,
    canEditHeader: false,
    canFilter: false,
    canDelete: false,
  },
  {
    ID: 422,
    accessor: "data_422",
    Header: "Multiline Text",
    typeDictID: 4,
    sheetID: 111,
    orderBy: 8,
    isShared: false,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "text",
      icon: "keyboard fas",
      multiline: true,
      entityType: "user",
      title: "Multiline Text",
      networkAvailableFieldID: 492,
    },
  },
  {
    ID: 421,
    accessor: "data_421",
    Header: "Address",
    typeDictID: 7,
    sheetID: 111,
    orderBy: 9,
    isShared: false,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "address",
      icon: "map-marker-alt fas",
      defaultCountryID: 1,
      allowChangeCountry: true,
      entityType: "household",
      title: "Address",
      networkAvailableFieldID: 5,
    },
  },
];

const sacramentFields = [
  {
    ID: 480,
    accessor: "data_480",
    Header: "Baptism Date",
    typeDictID: 5,
    sheetID: 135,
    orderBy: 4,
    isShared: false,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "date",
      icon: "water fas",
      includeYear: true,
      entityType: "user",
      title: "Baptism Date",
      networkAvailableFieldID: 80,
      fieldTypeInstanceStructureGroupingID: 1,
      defaultFieldTypeInstanceMapping: "BaptismDate",
      parentNetworkFieldID: 80,
    },
  },
  {
    ID: 479,
    accessor: "data_479",
    Header: "Baptism Location",
    typeDictID: 18,
    sheetID: 135,
    orderBy: 5,
    isShared: false,
    canEdit: false,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "date",
      icon: "water fas",
      includeYear: true,
      entityType: "user",
      title: "Baptism Location",
      networkAvailableFieldID: 80,
      fieldTypeInstanceStructureGroupingID: 1,
      defaultFieldTypeInstanceMapping: "BaptismLocation",
      parentNetworkFieldID: 80,
    },
  },
  {
    ID: 481,
    accessor: "data_481",
    Header: "Godparents",
    typeDictID: 4,
    sheetID: 135,
    orderBy: 6,
    isShared: false,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "text",
      icon: "user-friends fas",
      multiline: true,
      entityType: "user",
      title: "Godparents",
      networkAvailableFieldID: 11,
      fieldTypeInstanceStructureGroupingID: 1,
      defaultFieldTypeInstanceMapping: "BaptismGodparents",
      parentNetworkFieldID: 80,
    },
  },
  {
    ID: 482,
    accessor: "data_482",
    Header: "Baptism Record Book",
    typeDictID: 17,
    sheetID: 135,
    orderBy: 7,
    isShared: false,
    canEdit: false,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      defaultFieldTypeInstanceMapping: "BaptismRecordBook",
      parentNetworkFieldID: 80,
    },
  },
  {
    ID: 483,
    accessor: "data_483",
    Header: "Baptism Received Through RCIA/OCIA",
    typeDictID: 8,
    sheetID: 135,
    orderBy: 8,
    isShared: false,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "picker",
      icon: "file-alt fas",
      multiSelect: false,
      options: [
        {
          ID: 23,
          title: "Yes",
        },
        {
          ID: 24,
          title: "No",
        },
      ],
      entityType: "user",
      title: "Baptism Received Through RCIA/OCIA",
      networkAvailableFieldID: 17,
      fieldTypeInstanceStructureGroupingID: 1,
      defaultFieldTypeInstanceMapping: "BaptismReceivedThroughRCIAOCIA",
      parentNetworkFieldID: 80,
    },
  },
  {
    ID: 484,
    accessor: "data_484",
    Header: "Baptism Certificate",
    typeDictID: 16,
    sheetID: 135,
    orderBy: 9,
    isShared: false,
    canEdit: true,
    canEditHeader: false,
    canFilter: false,
    canDelete: true,
    extendedFieldData: {
      type: "file",
      icon: "file-certificate fas",
      entityType: "user",
      title: "Baptism Certificate",
      networkAvailableFieldID: 22,
      fieldTypeInstanceStructureGroupingID: 1,
      defaultFieldTypeInstanceMapping: "BaptismCertificate",
      parentNetworkFieldID: 80,
    },
  },
];

export const getGroupBoard = {
  success: true,
  groupID: 8,
  boardInfo: {
    ID: 111,
    title: "TestX",
    url: "TestX",
  },
  columns: [
    {
      Header: "",
      accessor: "name",
    },
    // ...basicFields,
    // ...extendedFields,
    ...sacramentFields,
  ],
  filteredTotal: 4,
  unfilteredTotal: 4,
  rows: [
    // {
    //   entityID: 3,
    //   entityType: "user",
    //   originalIndex: 0,
    //   name: "Group Admin",
    //   data_422:
    //     '{"value":"<p>St. George\'s<\\/p><p>123 Main St.<br>Main City, MO 12345<\\/p>"}',
    // },
    {
      entityID: 2,
      entityType: "user",
      originalIndex: 0,
      name: "Super Admin",
      data_479:
        '{"value":{"church":"First Baptist Main St","atCurrentChurch":false,"address":{"country":"US","addr1":"123 Peachtree Ave.","city":"Atlanta","state":"GA","zip":"30047"}}}',
      data_480: '{"month":1,"day":18,"year":1900}',
      data_481: '{"value":"Kim and Dan Smacks"}',
      data_482: '{"value":""}',
      data_483: "[]",
      data_484:
        '{"entityFieldResponseID":85,"secureFileID":3,"fileName":"0apdf3.pdf"}',
    },
    // {
    //   entityID: 4,
    //   entityType: "user",
    //   originalIndex: 0,
    //   name: "Note Sender",
    // },
    // {
    //   entityID: 19,
    //   entityType: "user",
    //   originalIndex: 0,
    //   name: "Mama Smith",
    //   data_419:
    //     '{"values":[{"optionListValueID":"8","optionListValue":"Female"}]}',
    //   data_420:
    //     '{"values":[{"optionListValueID":"3","optionListValue":"Medium"}]}',
    // },
  ],
  rowTotals: [],
  isShared: false,
  permissions: [],
  everyoneGroupID: 7,
  isApp: false,
  userID: 2,
};
